/**
 * Token aliases → palette (no duplicate hex here).
 * Edit colors in palette.js only.
 */
const { palette: p } = require("./palette.js");

const colors = {
  // Brand
  primary: p.brand,
  primaryHover: p.brandHover,
  primaryDark: p.brandDark,
  primaryLight: p.brandLight,
  primaryBorder: p.brandBorder,

  ctaOrange: p.brand,
  ctaOrangeHover: p.brandHover,
  orangeMuted: p.brandLight,
  orangeAccent: p.brand,

  white: p.white,
  bg: p.inkCanvas,
  surfaceAlt: p.surface,

  dark: p.ink,
  textMuted: p.inkMuted,
  textPlaceholder: p.inkFaint,
  grayMid: p.inkMuted,
  grayIcon: p.inkMid,
  grayNeutral: p.inkMuted,
  grayPlaceholder: p.inkFaint,
  slate: p.inkMuted,
  slateMuted: p.inkMid,
  slateDark: p.ink,
  charcoal: p.ink,
  charcoalSoft: p.inkSoft,

  border: p.line,
  borderLight: p.lineLight,
  borderSubtle: p.surface,
  borderInput: p.lineStrong,
  borderFaint: p.lineFaint,

  promoBg: p.brandSoft,
  promoBorder: p.brandBorder,
  promoText: p.brandDark,
  accentOrangeText: p.accentText,

  accentGreen: p.brandSoft,
  accentGreenText: p.brandDark,
  accentGreenAlt: p.brandLight,
  accentGreenTextAlt: p.brandHover,
  accentGreenSurface: p.brandSoft,

  success: p.brand,
  warning: p.warning,
  warningSurface: p.warningSurface,
  warningTint: p.warningTint,
  warningBorder: p.warningBorder,

  danger: p.danger,
  dangerSurface: p.dangerSurface,
  dangerBright: p.dangerBright,
  dangerSale: p.dangerSale,
  dangerBrand: p.dangerBrand,
  dangerDeep: p.dangerDeep,
  dangerDarker: p.dangerDarker,
  dangerLightBg: p.dangerLightBg,
  dangerLightBorder: p.dangerLightBorder,
  dangerLightSurface: p.brandSoft,
  dangerLightTint: p.dangerLightTint,

  info: p.info,
  infoSurface: p.infoLight,

  disabled: p.line,
  skeletonBase: p.line,
  skeletonShine: p.surface,
  surfaceHover: p.inkCanvas,
  surfaceMuted: p.surfaceMuted,
  surfacePanel: p.white,
  surfaceGray: p.surface,
  surfaceGrayAlt: p.line,
  surfaceBlueTint: p.infoLight,

  legacyGreen: p.accent,
  legacyGreenHover: p.accentHover,
  legacyGreenAlt: p.accentBright,
  legacyGreenDark: p.accentText,
  legacyGreenMui: p.accent,
  legacyGreenBootstrap: p.accentHover,
  legacyGreenBtn: p.accentText,

  blueLink: p.info,
  blueBootstrap: p.infoStrong,
  blueMui: p.info,
  blueSky: p.inkMuted,
  blueDeep: p.ink,
  blueNavy: p.ink,
  blueTeal: p.info,
  cyanAccent: p.inkMid,

  darkCanvas: p.night,
  darkSurface: p.ink,
  darkSoft: p.inkSoft,
  darkBody: p.night,
  darkPrimary: p.accentBright,
  darkLinkHover: p.accentMuted,
  darkFooterBg: p.ink,
  darkFooterBorder: p.inkMuted,
  darkForeground: p.inkOnDark,

  brandReceipt: p.brand,
  statusOk: p.brandSoft,
  statusLate: p.statusLate,

  black: p.ink,
  cropperShadow: p.inkSoft,
  editorRed: p.editorRed,

  a11yBg: p.ink,
  a11yBtn: p.inkMuted,
  a11yBtnBorder: p.inkSoft,
  a11yBtnHover: p.ink,
  a11yPanel: p.inkSoft,

  priceCompareHeading: p.ink,
  priceCompareSub: p.inkMuted,
  priceCompareBg: p.inkCanvas,
  priceCompareBorder: p.lineStrong,
  priceCompareMuted: p.inkFaint,
  priceCompareHighlight: p.brand,
  priceCompareActive: p.brandSoft,
  priceCompareShadow: p.brandBorder,

  filterTeal: p.brand,
  filterCancel: p.dangerSale,
};

const cssVar = (key) =>
  `var(--c-${key.replace(/([A-Z])/g, "-$1").toLowerCase()})`;

module.exports = { colors, palette: p, cssVar };
